import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import { connectComparison } from './ComparisonConnectors';
import ShingleComparisonItem from './ShingleComparisonItem';
import ComparisonDrawer from '../../../ComponentLibrary/ComparisonDrawer';

const ShinglesComparisonContainer = ({
  selectedShingles,
  isDrawerCollapsed,
  removeFromComparison,
  clearComparison,
  toggleDrawerCollapsed,
  shingles = [], // Translation function, fallback to key
}) => {
  // Transform selectedShingles UUIDs into full shingle data
  const comparisonItems = useMemo(
    () =>
      selectedShingles
        .map(uuid => {
          // Find the shingle that contains this color UUID
          const foundShingle = shingles.find(shingle => shingle.shingle_colors?.some(color => color.uuid === uuid));

          if (foundShingle) {
            const foundColor = foundShingle.shingle_colors.find(color => color.uuid === uuid);
            return {
              shingle: foundShingle,
              shingleColor: foundColor,
              uuid: foundColor.uuid,
              // Add any additional shingle properties that might contain pricing
              priceLevel: foundShingle.priceLevel || foundShingle.price_level,
              features: foundShingle.features,
              rating: foundShingle.rating,
              reviewCount: foundShingle.review_count,
            };
          }
          return null;
        })
        .filter(Boolean),
    [selectedShingles, shingles]
  );

  const handleCompare = () => {
    // Navigate to the comparison page
    const currentLocale = document.querySelector('html').getAttribute('lang') || 'en-us';
    const comparisonUrl = `/${currentLocale}/roofing/shingles/comparison`;
    window.location.href = comparisonUrl;
  };

  const handleItemClick = () => {
    // Collapse drawer when clicking on item (per requirements)
    if (!isDrawerCollapsed) {
      toggleDrawerCollapsed();
    }
  };

  const renderShingleItem = (item, onRemove) => (
    <ShingleComparisonItem
      key={item.uuid}
      shingle={item.shingle}
      shingleColor={item.shingleColor}
      onRemove={onRemove}
      onClick={handleItemClick}
    />
  );

  return (
    <ComparisonDrawer
      items={comparisonItems}
      maxItems={3}
      onClearAll={clearComparison}
      onRemoveItem={removeFromComparison}
      onCompare={handleCompare}
      renderItem={renderShingleItem}
      compareButtonText={count => `Compare (${count})`}
      isExpanded={!isDrawerCollapsed}
      onToggleExpanded={toggleDrawerCollapsed}
      headerText={
        comparisonItems?.length > 0 ? `${comparisonItems.length}/3 Products to Compare` : 'Compare up to three products'
      }
    />
  );
};

ShinglesComparisonContainer.propTypes = {
  selectedShingles: PropTypes.arrayOf(PropTypes.string),
  isDrawerCollapsed: PropTypes.bool,
  removeFromComparison: PropTypes.func,
  clearComparison: PropTypes.func,
  toggleDrawerCollapsed: PropTypes.func,
  shingles: PropTypes.arrayOf(
    PropTypes.shape({
      shingle_colors: PropTypes.arrayOf(
        PropTypes.shape({
          uuid: PropTypes.string,
        })
      ),
      priceLevel: PropTypes.number,
      price_level: PropTypes.number,
      features: PropTypes.shape({}),
      rating: PropTypes.number,
      review_count: PropTypes.number,
    })
  ),
};

ShinglesComparisonContainer.defaultProps = {
  selectedShingles: [],
  isDrawerCollapsed: true,
  removeFromComparison: null,
  clearComparison: null,
  toggleDrawerCollapsed: null,
  shingles: [],
};

export default connectComparison(ShinglesComparisonContainer);
